import {ck} from 'fire-wind-water';
import {settings} from '../../common/setting';

ck.json = true;

const suser = settings.schemaId ? (ck.cookie(`smarketMember_${settings.schemaId}`) || {}) : {};

export const user = {
  globalUserId: ck.cookie('globalUserId'),
  memberId: suser.memberId,
  session: suser.session
};